import { useRef, useCallback } from 'react'
import { createZustandStore, StoreContext, StoreScheme } from './shared/store/store'
import { TrillionViewer, TrillionViewerProps } from './trillion-viewer'
import { ErrorBoundary } from './viewer/components/ErrorBoundary/ErrorBoundary'
import { ShadowRootWrap } from '../../trillion-common/src/Components/shadow-root-wrap'

/**
 * Trillion viewer react library must use This component
 */
export const TrillionViewerWrap = (props: TrillionViewerProps) => {
  const storeRef = useRef<StoreScheme>(createZustandStore())

  const getApp = useCallback(
    () => (
      <ErrorBoundary>
        <StoreContext.Provider value={storeRef.current}>
          <TrillionViewer {...props} />
        </StoreContext.Provider>
      </ErrorBoundary>
    ),
    [],
  )

  if (import.meta.env.VITE_IS_LIBRARY_MODE) {
    const getAppWithInjectedStyle = () => (
      <>
        {getApp()}
        <style
          dangerouslySetInnerHTML={{
            __html: 'trillion_shadowroot_styles_link_to_replace',
          }}
        />
      </>
    )
    let appContent = (
      <>
        <ShadowRootWrap id="trillion_viewer_shadowroot_wrap">
          {getAppWithInjectedStyle}
        </ShadowRootWrap>
        <style
          dangerouslySetInnerHTML={{
            __html: `#trillion_viewer_shadowroot_wrap{width:100%;height:100%;overflow:hidden;display:block!important;}style{display:none!important;}`,
          }}
        />
      </>
    )
    if (props.disableShadowRoot) {
      appContent = getAppWithInjectedStyle()
    }

    return (
      <>
        {appContent}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Montserrat&display=swap"
        />
      </>
    )
  }

  return getApp()
}
